import { SchedulerLazyLoadingPlugin } from "../../internals/plugins/SchedulerLazyLoadingPlugin.mjs";
import { eventTimelinePremiumPresetSelectors } from "../../event-timeline-premium-selectors/index.mjs";

/**
 * The first fetch is gated on `state.hasInitialized`: without it, the selector
 * would return the same key at construction and at mount (defaults are enough
 * to compute it), so `registerStoreEffect` would never fire its first transition
 * and the initial fetch would never trigger.
 */
export class EventTimelinePremiumLazyLoadingPlugin extends SchedulerLazyLoadingPlugin {
  constructor(store) {
    super(store);
    store.registerStoreEffect(state => {
      if (!state.hasInitialized) {
        return null;
      }
      const viewConfig = eventTimelinePremiumPresetSelectors.config(state);
      return `${state.adapter.getTime(viewConfig.start)}|${state.adapter.getTime(viewConfig.end)}`;
    }, (previousKey, nextKey) => {
      if (previousKey === nextKey || !store.parameters.dataSource) {
        return;
      }
      this.scheduleFetch(() => {
        const viewConfig = eventTimelinePremiumPresetSelectors.config(store.state);
        return {
          start: viewConfig.start,
          end: viewConfig.end
        };
      }, previousKey === null);
    });
  }
}